module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAPCAQAAAB66ObCAAAAu0lEQVQY02NggINmu2Y7BnTQKt64qOF/w//GRa3icMH/TI05DR9AwmD4oSH7PxNQeCJfw0m4IAyebhdkaFJv0m04jCJ8ptG0XYGh4ULjoi6JhviGV2DB941ZPSIN0xvOMzRchJjbI9I4rXFBq3hDIljJRYgECJ5t1WvVaDgC5SFJ/G9saGyA20OORKNtw2WYBFAGIny50Rboxf0sDcUNn+E6PjcU72eBB0uLdMNKsMTKFmmMgOzg7+BH8ACUdbC9amYvNQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/data-icon.png
// module id = VpbH
// module chunks = 1 2 3